var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoperLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "193px",
    viewBox: "0 0 192 193",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Roper_White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.264715602 0.06 44.1538169 60.524261 44.1538169 60.524261 0.264715602 0.06 0.264715602"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Roper_White"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.131,54.911 C109.009,62.263 101.331,66.506 93.98,64.383 C86.631,62.26 82.389,54.577 84.512,47.231 C86.634,39.879 94.313,35.639 101.663,37.761 C109.015,39.882 113.253,47.559 111.131,54.911",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.557,141.532 C131.557,149.188 125.353,155.392 117.704,155.392 C110.054,155.392 103.85,149.188 103.85,141.532 C103.85,133.889 110.054,127.683 117.704,127.683 C125.353,127.683 131.557,133.889 131.557,141.532",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.591,149.793 C103.591,157.443 97.387,163.639 89.739,163.639 C82.085,163.639 75.884,157.443 75.884,149.793 C75.884,142.134 82.085,135.93 89.739,135.93 C97.387,135.93 103.591,142.134 103.591,149.793",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(75.000000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.591,178.483 C28.591,186.136 22.387,192.34 14.739,192.34 C7.085,192.34 0.884,186.136 0.884,178.483 C0.884,170.832 7.085,164.631 14.739,164.631 C22.387,164.631 28.591,170.832 28.591,178.483",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.174,12.49 C36.094,14.402 32.044,13.454 30.126,10.378 C28.21,7.299 29.162,3.248 32.234,1.336 C35.318,-0.576 39.37,0.364 41.282,3.443 C43.196,6.524 42.255,10.575 39.174,12.49",
    id: "Fill-11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.825,33.343 C105.793,35.847 100.488,34.609 97.979,30.577 C95.472,26.55 96.711,21.247 100.741,18.741 C104.77,16.232 110.079,17.475 112.581,21.505 C115.089,25.534 113.849,30.834 109.825,33.343",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.521,132.651 C124.261,130.233 120.334,122.39 122.751,115.132 C125.166,107.873 133.011,103.945 140.27,106.361 C147.53,108.777 151.455,116.625 149.041,123.881 C146.625,131.142 138.78,135.064 131.521,132.651",
    id: "Fill-14",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.266,137.417 C172.479,134.262 173.587,130.254 176.738,128.463 C179.892,126.672 183.9,127.784 185.689,130.931 C187.476,134.087 186.375,138.105 183.219,139.891 C180.066,141.674 176.057,140.573 174.266,137.417",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.12,132.577 C151.778,128.452 153.229,123.196 157.358,120.857 C161.485,118.512 166.733,119.964 169.078,124.089 C171.417,128.219 169.963,133.47 165.836,135.812 C161.71,138.157 156.461,136.705 154.12,132.577",
    id: "Fill-16",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.431,103.581 C132.851,104.627 125.86,99.332 124.813,91.756 C123.766,84.176 129.063,77.181 136.642,76.137 C144.222,75.088 151.215,80.385 152.26,87.962 C153.307,95.544 148.009,102.532 140.431,103.581",
    id: "Fill-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.872,88.943 C177.872,86.902 177.093,82.812 179.127,79.816 C181.162,76.814 185.25,76.038 188.247,78.068 C191.247,80.111 192.034,84.196 189.995,87.198 C187.957,90.192 183.874,90.98 180.872,88.943",
    id: "Fill-18",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.196,93.506 C156.269,90.841 155.245,85.491 157.911,81.56 C160.576,77.635 165.923,76.611 169.854,79.276 C173.779,81.941 174.799,87.296 172.134,91.222 C169.471,95.147 164.12,96.168 160.196,93.506",
    id: "Fill-19",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.477,75.192 C126.362,79.794 117.677,78.564 113.078,72.456 C108.478,66.342 109.704,57.65 115.818,53.051 C121.932,48.452 130.618,49.679 135.219,55.796 C139.818,61.91 138.591,70.593 132.477,75.192",
    id: "Fill-20",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.693,42.733 C157.081,42.407 154.414,39.219 154.73,35.608 C155.05,31.995 158.243,29.33 161.85,29.645 C165.462,29.971 168.139,33.157 167.815,36.77 C167.494,40.377 164.307,43.051 160.693,42.733",
    id: "Fill-21",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.954,56.736 C140.226,56.316 136.729,52.139 137.146,47.409 C137.564,42.686 141.742,39.191 146.47,39.608 C151.197,40.021 154.694,44.207 154.271,48.932 C153.855,53.657 149.676,57.152 144.954,56.736",
    id: "Fill-22",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.152,49.715 C84.342,56.67 81.29,64.893 74.336,68.081 C67.382,71.267 59.156,68.221 55.967,61.263 C52.776,54.309 55.829,46.083 62.784,42.897 C69.739,39.706 77.962,42.76 81.152,49.715",
    id: "Fill-23",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.055,15.218 C52.969,18.678 49.283,20.606 45.824,19.53 C42.36,18.442 40.438,14.755 41.517,11.298 C42.606,7.836 46.289,5.905 49.749,6.99 C53.206,8.074 55.136,11.759 54.055,15.218",
    id: "Fill-24",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.202,34.157 C63.784,38.69 58.955,41.21 54.424,39.794 C49.895,38.375 47.374,33.549 48.791,29.018 C50.208,24.49 55.041,21.968 59.568,23.386 C64.097,24.802 66.617,29.632 65.202,34.157",
    id: "Fill-25",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.665,18.34 C60.269,22.207 62.489,30.691 58.626,37.297 C54.761,43.896 46.275,46.12 39.671,42.255 C33.068,38.393 30.847,29.902 34.711,23.303 C38.575,16.696 47.059,14.478 53.665,18.34",
    id: "Fill-26",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.827,4.844 C13.922,8.301 12.01,11.993 8.557,13.097 C5.101,14.195 1.408,12.278 0.31,8.827 C-0.787,5.37 1.121,1.672 4.577,0.574 C8.03,-0.522 11.726,1.387 12.827,4.844",
    id: "Fill-28",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.545,60.299 C32.984,64.827 30.479,69.662 25.955,71.105 C21.434,72.543 16.598,70.04 15.157,65.514 C13.719,60.992 16.226,56.155 20.748,54.717 C25.27,53.276 30.105,55.78 31.545,60.299",
    id: "Fill-30",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoperLogo);
export default __webpack_public_path__ + "static/media/roper_logo.e4b345b27a8e51d582d7af20a16cf822.svg";
export { ForwardRef as ReactComponent };